import { realmType } from './configurationManager';

export const realmByUser = (user: string): realmType => {
    return user === 'third' ? 'third' : 'ambev';
};

export const userToNumber = (user: string): number => {
    return user === 'third' ? 1 : 0;
};
